/**
 * Created by vladislav on 01.02.2022
 */

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    COLOR_WINDOW_TEXT: new cc.Color(20, 74, 131, 255),
    PURPLE: new cc.Color(61, 29, 125, 255),
    COLOR_FORCE_MESSAGE_TEXT: new cc.Color(141, 74, 56),
    BLACK_STROKE: new cc.Color(0, 0, 0, 110),
    GREEN: new cc.Color(119, 229, 0, 46),
    COLOR_RED: new cc.Color(255, 80, 94, 46),
    DARK_BLUE_TEXT_COLOR: new cc.Color(20, 74, 131, 110),
    COLOR_BONUS: new cc.Color(215, 169, 255, 255),
    STICKERS_COLLECTION_COLOR: new cc.Color(225, 229, 119, 1),
    BARREL_ADS_ITEM_TITLE_COLOR: new cc.Color(49, 108, 150, 255),
    BROWN_BUTTON_COLOR: new cc.Color(128, 45, 23, 255),
    STICKER_LABEL_COLOR: new cc.Color(75, 111, 128, 255),
    DARK_TEXT_COLOR: new cc.Color(121, 75, 57, 255),
    WEEKLY_GOALS_TEXT_COLOR: new cc.Color(29, 102, 188, 255),
    WEEKLY_GOALS_AMOUNT_TEXT_COLOR: new cc.Color(21, 86, 160, 255)
});

cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    TILE_SHOP_WINDOW_TIMER_STROKE: {
        color: new cc.Color(196, 29, 58, 255),
        size: 1
    },

    TILE_SHOP_BADGE_STROKE: {
        color: new cc.Color(243, 78, 36, 255),
        size: 3
    },

    IMAGE_FONT_STROKE: {
        color: cleverapps.styles.COLORS.BLACK_STROKE,
        size: 2
    },

    IMAGE_FONT_STROKE_THIN: {
        color: cleverapps.styles.COLORS.BLACK_STROKE,
        size: 1
    },

    TITLE_TEXT_SHADOW: {
        color: cleverapps.styles.COLORS.BLACK,
        direction: cc.size(0, -2),
        blur: 6
    },

    WHITE_TEXT_SHADOW: {
        color: new cc.Color(0, 0, 0, 250),
        direction: cc.size(0, -2),
        blur: 6
    },

    RED_STROKE: {
        color: cleverapps.styles.COLORS.COLOR_RED,
        size: 2
    },

    DIALOGUE_PERSON_TITLE_TEXT_STROKE: {
        color: cleverapps.styles.COLORS.BLACK_STROKE,
        size: 1
    },

    DIALOGUE_PERSON_TITLE_TEXT_SHADOW: {
        color: cleverapps.styles.COLORS.BLACK,
        direction: cc.size(0, 0),
        blur: 3
    },

    LEADERS_STROKE: {
        color: new cc.Color(255, 90, 0, 255),
        size: 3
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LIGHTNING_RUSH_TITLE_TEXT: {
        size: 90,
        color: new cc.Color(255, 234, 0, 255),
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    LIGHTNING_RUSH_TIMER_TEXT: {
        name: "nostroke",
        size: 42,
        color: new cc.Color(255, 220, 132, 255)
    },

    LOADING_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE
    },

    SHOP_WINDOW_TILE_TITLE: {
        size: 64,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.RED_STROKE
    },

    TILE_SHOP_COINS_OFFER: {
        size: 64,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.RED_STROKE
    },

    UNITSSHOPTILE_AMOUNT: {
        size: 50
    },

    BUTTON_BROWN_TEXT: {
        size: 36,
        color: cleverapps.styles.COLORS.BROWN_BUTTON_COLOR
    },

    SHOP_WINDOW_SMALL_TILE_TITLE: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    PACKWINDOW_TEXT: {
        name: "default",
        size: 64,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.RED_STROKE
    },

    TILE_SHOP_WINDOW_BADGE_TIMER: {
        size: 22,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TILE_SHOP_WINDOW_TIMER_STROKE
    },

    UNITSSHOPTILE_NAME: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    UNITSSHOP_BOTTOM_TEXT: {
        size: 55,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    UNITSSHOP_BOTTOM_TIMER: {
        name: "default",
        size: 55
    },

    TOOLBAR_ITEM_TIMER_TEXT: {
        size: 27
    },

    SHOPTILE_LEFT: {
        size: 32,
        color: cleverapps.styles.COLORS.DARK_BLUE_TEXT_COLOR
    },

    UNITSSHOP_CART_AMOUNT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_BLUE_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },

    MENUBAR_TIMER_TEXT: {
        size: 48,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    RATE_WINDOW_TEXT: {
        size: 60,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },

    TILE_REWARDS: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.WHITE
    },
    PRODUCT_TILE_LIMIT_TEXT: {
        size: 32,
        color: cleverapps.styles.COLORS.DARK_BLUE_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },
    TIMER_TEXT: {
        size: 42,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    LEVELUPWINDOW_VALUE_TEXT: {
        size: 300,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },

    ORDERS_PLACEHOLDER_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE
    },

    ORDERS_WINDOW_TITLE: {
        size: 70,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    LOADING_ANIMATION_TEXT: {
        size: 54,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        name: "default"
    },

    WINDOW_SMALL_TEXT: {
        size: 34,
        color: cleverapps.styles.COLORS.DARK_BLUE_TEXT_COLOR
    },

    TOURNAMENT_PLAYER_TEXT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.BLACK,
        stroke: undefined,
        shadow: undefined
    },

    SIDEBAR_ICON_TEXT: {
        name: "default",
        size: 40,
        color: cleverapps.styles.COLORS.WHITE
    },

    WINDOW_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        stroke: undefined,
        shadow: undefined
    },

    SAME_ITEMS_TEXT: {
        size: 28,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    DARK_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    BUYINGREDIENTSWINDOW_TITLE: {
        size: 55,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        stroke: undefined,
        shadow: undefined
    },

    UNITICON_TITLE: {
        size: 36,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    UNITICON_LEVEL: {
        size: 36,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR
    },

    PROMOTION_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    EXTRA_WINDOW_TEXT: {
        size: 43,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    SMALL_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.WHITE,
        shadow: cleverapps.styles.DECORATORS.WHITE_TEXT_SHADOW
    },

    VERY_BIG_TEXT: {
        size: 100,
        color: cleverapps.styles.COLORS.COLOR_VICTORY,
        shadow: cleverapps.styles.DECORATORS.WHITE_TEXT_SHADOW
    },

    WINDOW_BIG_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    WINDOW_TITLE_TEXT: {
        size: 65,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },

    NOBG_WINDOW_TITLE_TEXT: {
        size: 65,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },

    FRIEND_REQUEST_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },

    MENUBAR_TEXT: {
        size: 46
    },

    DAILY_CUP_TITLE_TEXT: {
        size: 80,
        color: cleverapps.styles.COLORS.WHITE,
        shadow: cleverapps.styles.DECORATORS.TITLE_TEXT_SHADOW
    },
    SMALL_TEXT_ERROR: {
        size: 30,
        color: cleverapps.styles.COLORS.DARK_RED,
        stroke: undefined
    },
    LOSE_WINDOW_TEXT: {
        color: cleverapps.styles.COLORS.WHITE,
        size: 60
    },
    LOSE_WINDOW_TITLE_TEXT: {
        color: cleverapps.styles.COLORS.WHITE,
        size: 70
    },

    TILE_SHOP_OFFER_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE
    },
    // Old heroes had no PACK_TILE_REWARDS_TEXT, so the pack/offer/free-bundle rewards fell back to
    // the white TILE_SHOP_OFFER_TEXT above. The prefab tiles bind PACK_TILE_REWARDS_TEXT directly
    // (whose base is the dark COLOR_WINDOW_TEXT), so restore the white here.
    PACK_TILE_REWARDS_TEXT: {
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },
    REWARDS_LIST_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    BREAK_AMOUNT_TEXT: {
        name: "default",
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    FORCE_MESSAGE_TEXT: {
        size: 42,
        color: cleverapps.styles.COLORS.COLOR_FORCE_MESSAGE_TEXT
    },
    DIALOGUE_MESSAGE_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.COLOR_FORCE_MESSAGE_TEXT
    },
    SHOP_WINDOW_LIVES_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },
    SUBSCRIPTION_PRIZE_SUBTITLE: {
        size: 60
    },
    SUBSCRIPTION_MAIN_TEXT: {
        size: 48,
        color: cleverapps.styles.COLORS.WHITE
    },
    SUBSCRIPTION_BUTTON_TITLE: {
        size: 36,
        color: cleverapps.styles.COLORS.WHITE
    },
    TERMS_TEXT: {
        size: 32,
        color: cleverapps.styles.COLORS.WHITE
    },
    TERMS_LINK_TEXT: {
        size: 32,
        color: new cc.Color(200, 200, 200, 200)
    },
    BADGE_TEXT: {
        size: 33,
        color: cleverapps.styles.COLORS.WHITE
    },
    KNOCKOUT_WINDOW_COUNTDOWN_TEXT: {
        size: 70,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    DIALOGUE_PERSON_TITLE_TEXT: {
        size: 52,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.DIALOGUE_PERSON_TITLE_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.DIALOGUE_PERSON_TITLE_TEXT_SHADOW
    },
    PACKWINDOW_LABEL_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    LEVEL_TITLE_TEXT: {
        name: "nostroke",
        size: 45,
        color: new cc.Color(48, 83, 120, 255)
    },
    LEVEL_CURRENT_TITLE_TEXT: {
        size: 45
    },
    LEVEL_NOT_PASSED_TITLE_TEXT: {
        name: "nostroke",
        size: 45,
        color: new cc.Color(95, 95, 95, 255)
    },
    LEVEL_PASSED_TITLE_TEXT: {
        size: 45
    },

    VIPREWARDEDWINDOW_DESCRIPTION_TEXT: {
        size: 56
    },

    VIPREWARDEDWINDOW_NOTE_TEXT: {
        size: 38
    },

    PROLONG_BUTTON_AMOUNT_TEXT: {
        size: 48,
        color: cleverapps.styles.COLORS.WHITE
    },

    GUIDEWINDOW_DESCRIPTION_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        lineHeight: 60
    },

    LIGHT_TITLE_TEXT: {
        size: 42,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX,
        shadow: undefined
    },

    LEVEL_REWARD_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_BROWN
    },

    SHOP_USER_GOLD_TEXT: {
        name: "nostroke",
        size: 33,
        color: cleverapps.styles.COLORS.COLOR_FORCE_MESSAGE_TEXT
    },

    BONUSBG_TITLE: {
        color: new cc.Color(160, 74, 31, 255),
        stroke: undefined
    },

    BONUS_WORLD_WINDOW_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    MENUBAR_LEVEL_TEXT: {
        size: 66
    },

    MENUBAR_PROGRESS_TEXT: {
        size: 31
    },

    MENUBAR_LEVEL_WITH_AVATAR_TEXT: {
        size: 30
    },

    HERO_ABILITIES_TEXT: {
        size: 43,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    HERO_UPGRADE: {
        size: 43,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    HERO_STATS_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    SHOP_LIVES_PRODUCT_TILE_DESCRIPTION_TEXT: {
        size: 41,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    EXP_INFO_WINDOW_AMOUNT_TEXT: {
        size: 47,
        color: cleverapps.styles.COLORS.WHITE
    },

    LANTERN_TIMER_FONT: {
        size: 43,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    MISSION_WINDOW_COUNTDOWN_TEXT: {
        size: 43,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    FIGURE_DRAGON_LIVES_TEXT: {
        size: 36,
        color: cleverapps.styles.COLORS.WHITE
    },

    OPENCHESTWINDOW_TITLE_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        stroke: undefined,
        shadow: undefined
    },

    BONUSSALE_PRODUCT_REWARD: {
        name: "stroke",
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    BOOSTER_BEFORE_AMOUNT_TEXT: {
        name: "default",
        size: 36
    },

    UNIT_PROB: {
        size: 32,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        stroke: undefined,
        shadow: undefined
    },

    TILE_SHOP_BADGE_TEXT: {
        size: 58,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    LEVELUPWINDOW_TITLE_TEXT: {
        size: 100,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },

    LIGHT_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR
    },

    BARREL_ADS_TITLE: {
        size: 37,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    BARREL_ADS_ITEM_TITLE: {
        size: 45,
        color: cleverapps.styles.COLORS.BARREL_ADS_ITEM_TITLE_COLOR
    },

    TRAVEL_BOOK_MESSAGE_TEXT: {
        size: 28
    },

    PRIZE_BAR_TEXT: {
        size: 38
    },

    BOOSTERS_BEFORE_TEXT: {
        size: 57,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    LANTERN_START_COMPONENT_TEXT: {
        size: 57,
        lineHeight: 45,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LANTERN_START_COMPONENT_STROKE
    },

    LANTERN_WINDOW_TEXT: {
        size: 34,
        color: cleverapps.styles.COLORS.DARK_BLUE_TEXT_COLOR
    },

    CUSTOMER_SUBTITLE_TEXT: {
        name: "default",
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    NOTIFICATION_TEXT: {
        color: cleverapps.styles.COLORS.WHITE
    },

    BUTTON_BOOSTER: {
        size: 35
    },

    AMOUNT_BOOSTER: {
        size: 40
    },

    GUIDE_WINDOW_VERTICAL_STAGE_TEXT: {
        size: 55
    },

    CONGRATE_TEXT: {
        size: 96,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.MESSAGE_BLUE_STROKE
    },

    TOOLTIP_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        stroke: undefined
    },

    UNITFAMILY_TITLE: {
        size: 46,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        stroke: undefined,
        shadow: undefined
    },

    HERODETAILS_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        stroke: undefined,
        shadow: undefined
    },

    PROFILE_WINDOW_NICKNAME_GENERATOR_NICKNAME_TEXT: {
        size: 40,
        color: new cc.Color(94, 143, 236, 255)
    },

    PROFILE_WINDOW_NICKNAME_GENERATOR_PREFIX_TEXT: {
        size: 45,
        color: new cc.Color(57, 99, 157, 255)
    },

    PROFILE_WINDOW_AVATAR_PICKER_TEXT: {
        size: 40,
        color: new cc.Color(57, 99, 157, 255)
    },

    MENUBAR_TOOLTIP_TEXT: {
        color: cleverapps.styles.COLORS.DARK_BLUE_TEXT_COLOR
    },

    MENUBAR_TOOLTIP_NUMBERS_TEXT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.DARK_BLUE_TEXT_COLOR
    },

    LEADERS_TIMER_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.FEAST_MISSION_TIMER_STROKE,
        shadow: undefined
    },

    LEADERS_MAIN_TITLE_TEXT: {
        size: 80,
        color: new cc.Color(255, 228, 0, 255),
        stroke: cleverapps.styles.DECORATORS.MISSION_STROKE,
        shadow: cleverapps.styles.DECORATORS.MISSION_SHADOW
    },

    SIDEBAR_ICON_PLACE: {
        size: 44,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    }
});

if (cleverapps.styles.BonusLevelView) {
    cleverapps.overrideStyles(cleverapps.styles.BonusLevelView, {
        horizontal: {
            y: { align: "bottom", dy: 50 }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.TileBadge, {
    x: { align: "center", dx: 1 },
    y: { align: "center", dy: 8 },
    width: 110,
    rotation: 20
});

cleverapps.overrideStyles(cleverapps.styles.FriendRequestView, {
    Icon: {
        x: 243
    }
});

if (cleverapps.styles.CaravanTileView) {
    cleverapps.overrideTemplates(cleverapps.styles.UI.Button.Images, {
        caravan_tile_help_button: {
            button_png: bundles.help_button.frames.help_button_png,
            button_on_png: bundles.help_button.frames.help_button_on_png
        }
    });
}

if (cleverapps.styles.HeroDetailsLayout) {
    cleverapps.overrideTemplates(cleverapps.styles.UI.Button.Images, {
        hero_help_button: {
            button_png: bundles.help_button.frames.help_button_png,
            button_on_png: bundles.help_button.frames.help_button_on_png
        }
    });
}

if (cleverapps.styles.UnitOnCell) {
    cleverapps.overrideStyles(cleverapps.styles.UnitOnCell, {
        ground: {
            x: 3,
            y: -60
        }
    });
}

if (cleverapps.styles.UnitsShopCart) {
    cleverapps.overrideStyles(cleverapps.styles.UnitsShopCart, {
        amountBlock: {
            x: { align: "right", dx: -30 },
            y: { align: "bottom", dy: 4 }
        },

        item: {
            scale: 0.6,
            firstItem: {
                oneItem: {
                    x: { align: "center", dx: 12 },
                    y: { align: "bottom", dy: 85 }
                },
                twoItems: {
                    x: { align: "center", dx: -3 },
                    y: { align: "bottom", dy: 74 }
                }
            },

            secondItem: {
                x: { align: "center", dx: 18 },
                y: { align: "bottom", dy: 100 }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.SelectFriendWindow, {
    withFriends: {
        friendContainer: {
            Name: {
                height: 33,
                y: 32
            }
        }
    }
});

if (cleverapps.styles.BoosterBeforeView) {
    cleverapps.overrideStyles(cleverapps.styles.BoosterBeforeView, {
        width: 153,
        height: 156,

        textAvailable: {
            y: { align: "bottom", dy: 4 },
            width: 115,

            bg: {
                x: { align: "center", dx: 0 },
                y: { align: "bottom", dy: -10 },
                width: 146
            }
        },

        price: {
            height: 65
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.MinimalDialogue, {
    person: {
        margin: 30
    },

    text: {
        maxHeight: 400,

        arrow: {
            left: {
                x: { align: "left", dx: -33 },
                y: { align: "center", dy: 0 }
            },
            right: {
                x: { align: "right", dx: 30 },
                y: { align: "center", dy: 0 }
            }
        },

        padding: {
            left: 30,
            right: 30
        },
        verticalPadding: {
            top: 15,
            bottom: 20,
            left: 20,
            right: 20
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DialogueViewHorizontal, {
    widthPadding: 30,

    arrow: {
        y: { align: "top", dy: 41 }
    },

    text: {
        padding: {
            x: 50,
            y: 50
        },
        verticalPadding: {
            fromWallX: 30,
            x: 30,
            y: 40
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DialoguePersonTitleView, {
    text: {
        y: { align: "center", dy: 3 },
        padding: {
            x: 25,
            y: 15
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.RateWindow, {
    text: {
        y: { align: "center" }
    }
});

cleverapps.overrideStyles(cleverapps.styles.LoseWindow, {
    content: {
        padding: {
            top: 20
        }
    },

    life: {
        width: 70,
        height: 60
    },

    noBackground: true
});

cleverapps.overrideStyles(cleverapps.styles.MenuBarItem, {
    bg: {
        width: 265,
        height: 76,
        timerHeight: 122,
        minWidth: 247,
        padding: {
            right: 16,
            top: 0,
            bottom: 2
        }
    },

    items: {
        GoldItem: {
            icon: {
                scale: 1.36
            }
        },

        CoinsItem: {
            icon: {
                scale: 1.36
            }
        },

        LivesItem: {
            bg: {
                width: 291
            },

            icon: {
                scale: 1.07
            }
        },

        WandsItem: {
            icon: {
                scale: 1.29
            }
        },

        WorkersItem: {
            bg: {
                width: 291
            },

            icon: {
                scale: 1.36
            }
        }
    },

    icon: {
        x: 15
    },

    plusButton: {
        scale: 1.55,
        offset: {
            x: -15,
            y: -3
        }
    },

    iconText: {
        position: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 6 }
        }
    },

    attention: {
        x: { align: "right", dx: 7 },
        y: { align: "bottom", dy: -18 }
    },

    timer: {
        x: { align: "center", dx: 23 },
        y: { align: "bottom", dy: 8 },
        width: 160
    },

    premiumSticker: {
        y: { align: "center", dy: 45 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.MenuBarTextView, {
    noColoredText: true,

    amountText: {
        dy: -4
    }
});

cleverapps.overrideStyles(cleverapps.styles.Tabs, {
    margin: 20,

    buttons: {
        width: 127,
        height: 96,

        padding: {
            bottom: 15
        }
    },

    attention: {
        x: { align: "left", dx: -20 },
        y: { align: "top", dy: -5 }
    }
});

cleverapps.styles.UI.glyphScale = {
    scale: 0.85
};

cleverapps.overrideStyles(cleverapps.styles.UI.Avatar, {
    x: 16,
    top: 16,
    bottom: 16
});

if (cleverapps.styles.KnockoutPlayersView) {
    cleverapps.overrideStyles(cleverapps.styles.KnockoutPlayersView, {
        opponent: [
            { x: { align: "right", dx: -10 }, y: { align: "top", dy: -125 } },
            { x: { align: "left", dx: 10 }, y: { align: "top", dy: -430 } },
            { x: { align: "left", dx: 10 }, y: { align: "top", dy: -430 } }
        ]
    });
}

cleverapps.overrideStyles(cleverapps.styles.SettingsWindow, {
    padding: {
        top: 10,
        bottom: -15
    },

    user: {
        padding: {
            top: -20,
            bottom: 10,
            left: -10,
            right: -10
        }
    },

    button: {
        width: 550,
        height: 125,

        text: {
            width: 400
        }
    },

    grid: {
        margin: {
            x: 100,
            y: 30
        }
    },

    avatar: {
        padding: {
            left: 20,
            right: 0,
            top: 10,
            bottom: 10
        },

        size: {
            width: 175,
            height: 178
        }
    },

    invite: {
        position: [{
            x: { align: "right", dx: -15 },
            y: { align: "top", dy: -15 }
        }, {
            x: { align: "right", dx: -15 },
            y: { align: "top", dy: -15 }
        }, {
            x: { align: "right", dx: -15 },
            y: { align: "top", dy: -15 }
        }]
    },

    text: {
        size: [{ width: 300 }, { width: 800 }, { width: 800 }]
    },

    controlButton: {
        margin: 15,

        width: 92,
        height: 101
    }
});

cleverapps.overrideStyles(cleverapps.styles.LanguageButton, {
    height: 104,

    fontSize: {
        default: 40
    }
});

cleverapps.overrideStyles(cleverapps.styles.AboutWindow, {
    button: {
        height: 104
    }
});

cleverapps.overrideTemplates(cleverapps.styles.UI.Button.Images, {
    settings_control_button: {
        button_png: bundles.buttons.frames.blue_round_button,
        button_on_png: bundles.buttons.frames.blue_round_button_on,
        button_off_png: bundles.buttons.frames.blue_round_button_off,
        SKIP_RESOLUTION: {
            padding: {
                left: 0.05,
                right: 0.05,
                top: 0.05,
                bottom: 0.12
            }
        }
    },

    settings_control_red_button: {
        button_png: bundles.buttons.frames.red_round_button_png,
        button_on_png: bundles.buttons.frames.red_round_button_on_png,
        button_off_png: bundles.buttons.frames.red_round_button_off_png,
        SKIP_RESOLUTION: {
            padding: {
                left: 0.05,
                right: 0.05,
                top: 0.05,
                bottom: 0.12
            }
        }
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    CURRENT_TEXT: {
        font: bundles.game.urls.game_simple_font_ttf
    },

    LETTERS_TEXT: {
        font: bundles.game.urls.game_simple_font_ttf
    },

    BOARD_TEXT: {
        font: bundles.game.urls.game_simple_font_ttf
    },

    SELECTED_LETTERS_TEXT: {
        font: bundles.game.urls.game_simple_font_ttf,
        size: 80,
        color: cleverapps.styles.COLORS.SELECTED_LETTER
    },

    SETTINGS_WINDOW_NAME_TEXT: {
        name: "nostroke",
        size: 43,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    SETTINGS_WINDOW_FOLLOW_US_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    SETTINGS_WINDOW_ID_TEXT: {
        name: "nostroke",
        size: 36,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    SETTINGS_WINDOW_VERSION_TEXT: {
        name: "nostroke",
        size: 33,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    WEEKLY_GOALS_DAY_TEXT: {
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        size: 30
    },

    WEEKLY_GOALS_DAY_CLOSED_TEXT: {
        size: 30,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    WEEKLY_GOALS_POINTS_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.WEEKLY_GOALS_TEXT_COLOR,
        stroke: undefined
    },

    WEEKLY_GOALS_BAR_TEXT: {
        color: cleverapps.styles.COLORS.WEEKLY_GOALS_AMOUNT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    WEEKLY_GOALS_REWARD_TEXT: {
        color: cleverapps.styles.COLORS.WEEKLY_GOALS_TEXT_COLOR
    },

    WEEKLY_GOALS_PRIZE_TEXT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.WEEKLY_GOALS_AMOUNT_TEXT_COLOR
    }
});

cleverapps.overrideStyles(cleverapps.styles.CloseButton, {
    scale: [0.8, 1, 1],
    position: [{
        x: { align: "right", dx: 16 },
        y: { align: "top", dy: 18 }
    }, {
        x: { align: "right", dx: 16 },
        y: { align: "top", dy: 22 }
    }, {
        x: { align: "right", dx: 16 },
        y: { align: "top", dy: 22 }
    }]
});

cleverapps.overrideStyles(cleverapps.styles.Window, {
    border: {
        x: 17,
        top: 96,
        bottom: 25
    },
    padding: {
        x: 40,
        top: 55,
        bottom: 55
    },
    HelpButton: {
        position: [{
            x: { align: "left", dx: 25 },
            y: { align: "top", dy: -15 }
        }, {
            x: { align: "left", dx: 35 },
            y: { align: "top", dy: -25 }
        }, {
            x: { align: "left", dx: 35 },
            y: { align: "top", dy: -25 }
        }],
        zOrder: 3
    },
    BottomButton: {
        height: 104
    },

    Background: {
        padding: {
            x: 4,
            y: 20
        }
    },

    windowShowUpAnimation: {
        name: "defaultHeroes"
    }
});

if (cleverapps.styles.StarChestWindow) {
    cleverapps.overrideStyles(cleverapps.styles.StarChestWindow, {
        margin: 40,

        chest: {
            height: 300,

            y: {
                align: "center",
                dy: 40
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.PrizeBarComponent, {
    progressBar: {
        barText: {
            dy: -2
        }
    },

    prize: {
        x: { align: "right", dx: 50 },
        y: { align: "center", dy: 6 }
    },

    mark: {
        x: { align: "right", dx: 20 },
        y: { align: "center", dy: 0 }
    },

    button: {
        y: { align: "center", dy: -2 }
    }
});

if (cleverapps.styles.DailyCupView) {
    cleverapps.overrideStyles(cleverapps.styles.DailyCupView, {
        title: {
            width: 500,
            height: 97,

            bg: {
                x: { align: "center" },
                y: { align: "center", dy: -15 }
            },

            text: {
                width: 360,
                y: { align: "center", dy: -7 }
            }
        },

        playButton: {
            width: 300,
            height: 100
        }
    });
}

if (cleverapps.styles.CupTimer) {
    cleverapps.overrideStyles(cleverapps.styles.CupTimer, {
        textNode: {
            width: 500
        }
    });
}

if (cleverapps.styles.BackgroundsWindow) {
    cleverapps.overrideStyles(cleverapps.styles.BackgroundsWindow, {
        padding: {
            right: -25,
            left: -25
        },

        tape: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 35 },
            withName: {
                x: { align: "center", dx: 0 },
                y: { align: "bottom", dy: 35 }
            },
            text: false
        },

        item: {
            bg: {
                padding: {
                    x: 10,
                    y: 10
                }
            }
        },

        bar: {
            x: { align: "center", dx: -25 },
            y: { align: "bottom", dy: 55 }
        }
    });
}

if (cleverapps.styles.ExtendUnlimitedLivesWindow) {
    cleverapps.overrideStyles(cleverapps.styles.ExtendUnlimitedLivesWindow, {
        animation: {
            height: 300
        }
    });
}

if (cleverapps.styles.CookieJarView) {
    cleverapps.overrideStyles(cleverapps.styles.CookieJarView, {
        scale: 0.6
    });
}

cleverapps.overrideStyles(cleverapps.styles.ConfirmExitWindow, {
    animation: {
        width: 200,
        height: 200
    }
});

if (cleverapps.styles.ProlongationOfferView) {
    cleverapps.overrideStyles(cleverapps.styles.ProlongationOfferView, {
        button: { height: 100 }
    });
}

cleverapps.overrideStyles(cleverapps.styles.WindowTitle.Types, {
    bg_window: {
        background: undefined,
        titleSideOffset: {
            x: 100
        },

        scale: [0.8, 1, 1],
        position: [{
            x: { align: "center" },
            y: { align: "top", anchor: false, dy: -66 }
        }, {
            x: { align: "center" },
            y: { align: "top", anchor: false, dy: -80 }
        }, {
            x: { align: "center" },
            y: { align: "top", anchor: false, dy: -80 }
        }],

        text: {
            y: { align: "center", dy: 32 }
        },

        helpButton: {
            x: { align: "left", dx: 40 },
            y: { align: "center", dy: 15 },
            padding: {
                x: 30
            }
        }
    },

    nobg_window: {
        fontSize: [50, 65, 65],
        background: {
            padding: {
                x: 140
            }
        },

        text: {
            x: { align: "center" },
            y: { align: "center", dy: 17 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.NotificationView, {
    progress: {
        height: 52
    }
});

cleverapps.overrideStyles(cleverapps.styles.AdBlockWindow, {
    window: {
        padding: {
            top: 160
        }
    }
});

if (cleverapps.styles.ExtraWindow) {
    cleverapps.overrideStyles(cleverapps.styles.ExtraWindow, {
        window: {
            padding: {
                top: 100,
                bottom: 80
            },
            CloseButton: {
                x: { align: "right", dx: 20 },
                y: { align: "top", dy: 20 }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.LevelStartWindow, {
    padding: {
        top: 30
    },

    lanternStart: {
        margin: 25,
        padding: {
            left: -25,
            right: -25,
            top: 5
        },

        coinBadge: {
            label: {
                anchor: { x: 0.5, y: 0.5 },
                x: { align: "center" },
                y: { align: "center" },
                bonusText: {
                    width: 150,
                    height: 95
                }
            },
            x: { align: "right", dx: 0 },
            y: { align: "bottom", dy: 164 }
        }
    }
});
if (cleverapps.config.type === "match3") {
    cleverapps.overrideStyles(cleverapps.styles.LevelStartWindow, {
        hardLevel: {
            x: { align: "right", dx: -50 },
            y: { align: "bottom", dy: 50 },
            pulseUp: true
        }
    });
}

if (cleverapps.styles.LevelUpWindow) {
    cleverapps.overrideStyles(cleverapps.styles.LevelUpWindow["default"], {
        animation: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 120 }
        },

        title: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 240 }
        },

        value: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -15 }
        },

        rewards: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 0 }
        }
    });
}

if (cleverapps.styles.ShortMetaProgressView) {
    cleverapps.overrideStyles(cleverapps.styles.ShortMetaProgressView, {
        dy: 195,

        margin: {
            x: 20,
            y: 30,
            mobileY: 50
        }
    });
}

if (cleverapps.styles.AvatarMenuBarView) {
    cleverapps.overrideStyles(cleverapps.styles.AvatarMenuBarView, {
        height: 91,

        level: {
            x: { align: "left", dx: -20 },
            y: { align: "bottom", dy: -17 },
            scale: [1.25, 1, 1],
            text: {
                x: { align: "center", dx: -1 },
                y: { align: "center", dy: -5 }
            },

            collections: {
                x: { align: "left", dx: -15 },
                y: { align: "bottom", dy: -36 },
                text: {
                    x: { align: "center", dx: -1 },
                    y: { align: "center", dy: 5 }
                }
            }
        },

        avatar: {
            x: { align: "center" },
            y: { align: "top" },

            size: {
                width: 185,
                height: 195
            },

            mobileSize: [{
                width: 163,
                height: 173
            }, {
                width: 185,
                height: 195
            }, {
                width: 185,
                height: 195
            }],

            padding: 0
        },

        progress: {
            x: { align: "center", dx: 20 },
            y: { align: "bottom", dy: -2 },

            width: 130,
            mobileWidth: [117, 130, 130]
        },

        toolTipContent: {
            margin: 20
        }
    });
}

if (cleverapps.styles.QuestsTableView) {
    cleverapps.overrideStyles(cleverapps.styles.QuestsTableView, {
        size: {
            width: 210,
            height: 580
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.RestoreProgressButton, {
    content: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 8 }
    }
});

if (cleverapps.styles.QuestIcon) {
    cleverapps.overrideStyles(cleverapps.styles.QuestIcon, {
        progress: {
            x: { align: "center" },
            y: { align: "bottom", dy: -2 },

            text: {
                x: { align: "center" },
                y: { align: "center", dy: -2 }
            }
        }
    });
}

if (cleverapps.styles.UnitsLibraryWindow) {
    cleverapps.overrideStyles(cleverapps.styles.UnitsLibraryWindow, {
        size: [{
            width: 940,
            height: 1364
        }, {
            width: 1364,
            height: 960
        }, {
            width: 1364,
            height: 960
        }],

        padding: {
            x: 20,
            y: 2
        },

        tabs: {
            position: [{
                x: { align: "left", dx: 50 },
                y: { align: "top", dy: 85 }
            }, {
                x: { align: "left", dx: 120 },
                y: { align: "top", dy: 85 }
            }, {
                x: { align: "left", dx: 120 },
                y: { align: "top", dy: 85 }
            }],
            direction: cleverapps.UI.HORIZONTAL,
            type: Tabs.Types.tabs_top,
            size: [{
                width: 144,
                height: 92
            }, {
                width: 188,
                height: 92
            }, {
                width: 188,
                height: 92
            }],
            margin: [{ margin: -6 }, { margin: -6 }, { margin: -6 }],
            iconMaxScale: [1.2, 1, 1],
            changeIconColor: false,
            changeIconOpacity: true,

            selectAnimation: "heroes",

            zOrder: -1,

            attention: {
                x: { align: "right", dx: -10 },
                y: { align: "top", dy: 5 }
            }
        },

        window: {
            border: {
                top: 104,
                bottom: 40
            },

            Foreground: {
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                }
            }
        }
    });
}

if (cleverapps.styles.UnitsTab) {
    cleverapps.overrideStyles(cleverapps.styles.UnitsTab, {
        margin: 20,
        padding: {
            left: 0,
            right: 0,
            bottom: 20,
            top: 20
        }
    });
}

if (cleverapps.styles.FamilyLayout) {
    cleverapps.overrideStyles(cleverapps.styles.FamilyLayout, {
        title: {
            x: { align: "center" },
            y: { align: "top", dy: 0 },

            padding: {
                x: 100,
                y: 2
            }
        },

        grid: {
            position: {
                x: { align: "left" },
                y: { align: "center", dy: 0 }
            },

            padding: {
                x: 30,
                top: 65,
                bottom: 30
            },

            separator: false
        }
    });
}

if (cleverapps.styles.UnitLibraryIcon) {
    cleverapps.overrideStyles(cleverapps.styles.UnitLibraryIcon, {
        footer: false
    });
}

if (cleverapps.styles.HeroDetailsLayout) {
    cleverapps.overrideStyles(cleverapps.styles.HeroDetailsLayout, {
        height: 320,

        buttonInfo: {
            x: { align: "left", dx: 204 },
            y: { align: "top", dy: -84 }
        },

        infoHeroText: {
            x: { align: "center", dx: 125 },
            y: { align: "center", dy: -16 },

            size: [{ width: 626, height: 260 }, { width: 1006, height: 260 }, { width: 1006, height: 260 }]
        },

        grid: {
            size: [{ width: 626 }, { width: 1046 }, { width: 1046 }],

            position: [{
                x: { align: "left", dx: 260 },
                y: { align: "center", dy: -20 }
            }, {
                x: { align: "left", dx: 270 },
                y: { align: "center", dy: -20 }
            }, {
                x: { align: "left", dx: 270 },
                y: { align: "center", dy: -20 }
            }],

            scroll: [{
                x: { align: "left", dx: 260 },
                y: { align: "center", dy: -20 }
            }, {
                x: { align: "left", dx: 270 },
                y: { align: "center", dy: -20 }
            }, {
                x: { align: "left", dx: 270 },
                y: { align: "center", dy: -20 }
            }],

            margin: {
                x: 44,
                y: 20
            },

            padding: {
                x: 10,
                top: 40,
                bottom: 60
            }
        },

        heroIcon: {
            position: [{
                x: { align: "left", dx: 20 },
                y: { align: "bottom", dy: 30 }
            }, {
                x: { align: "left", dx: 30 },
                y: { align: "bottom", dy: 30 }
            }, {
                x: { align: "left", dx: 30 },
                y: { align: "bottom", dy: 30 }
            }]
        }
    });
}

if (cleverapps.styles.HeroIcon) {
    cleverapps.overrideStyles(cleverapps.styles.HeroIcon, {
        icon: {
            x: { align: "center", dx: -3 },
            y: { align: "bottom", dy: 14 }
        },

        attention: {
            x: { align: "left", dx: 15 },
            y: { align: "bottom", dy: 15 }
        }
    });
}

if (cleverapps.styles.UnitLibraryIcon) {
    cleverapps.overrideStyles(cleverapps.styles.UnitLibraryIconBg, {
        width: 174,
        height: 178,

        selected: {
            width: 174,
            height: 178,
            backgroundDisabled: true
        },

        title: false,

        icon: {
            x: 0,
            y: 0,
            width: 150,
            height: 150,
            maxScale: 1.3
        },

        iconUnknown: {
            x: { align: "center" },
            y: { align: "center", dy: 0 }
        },

        nextArrow: {
            x: { align: "right", dx: 14 },
            y: { align: "center", dy: 0 }
        }
    });

    cleverapps.overrideStyles(cleverapps.styles.UnitLibraryIconFooter, {
        width: 200,
        height: 100,

        collectButton: {
            height: 63,
            type: cleverapps.styles.UI.Button.Images.small_button_green
        }
    });
}

if (cleverapps.styles.HeroesTab) {
    cleverapps.overrideStyles(cleverapps.styles.HeroesTab, {
        size: [{ width: 900 }, { width: 1324 }, { width: 1324 }]
    });
}

if (cleverapps.styles.UnitLibraryIconPrize) {
    cleverapps.overrideStyles(cleverapps.styles.UnitLibraryIconPrize, {
        prize: {
            scale: 0.8
        }
    });
}

if (cleverapps.styles.CustomerIngredientViewInfoView) {
    cleverapps.overrideStyles(cleverapps.styles.CustomerIngredientViewInfoView, {
        bg: {
            width: 78,
            height: 74,
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 1 }
        }
    });
}

if (cleverapps.styles.InfoView) {
    cleverapps.overrideStyles(cleverapps.styles.InfoView, {
        button: {
            height: 63,
            type: {
                default: cleverapps.styles.UI.Button.Images.small_button_green,
                secondary: cleverapps.styles.UI.Button.Images.small_button_blue
            }
        },

        pointer: {
            y: -8
        },

        label: {
            padding: {
                x: 6,
                top: 15,
                bottom: 15
            }
        },

        timer: {
            padding: {
                x: 6,
                top: 15,
                bottom: 20
            }
        },

        upgradableLevel: {
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: 54 },

            text: {
                x: { align: "center", dx: -3 },
                y: { align: "center", dy: -4 }
            }
        }
    });
}

if (cleverapps.styles.PrizeView) {
    cleverapps.overrideStyles(cleverapps.styles.PrizeView, {
        width: 90,
        height: 100,

        pointer: {
            dy: -1
        }
    });
}

if (cleverapps.styles.SpeedUpWindow) {
    cleverapps.overrideStyles(cleverapps.styles.SpeedUpWindow, {
        timer: {
            button: {
                height: 99
            }
        },

        buttons: {
            padding: {
                bottom: 10
            },

            button: {
                width: 340,
                height: 104
            }
        }

    });
}

if (cleverapps.styles.PromotionSaleWindow) {
    cleverapps.overrideStyles(cleverapps.styles.PromotionSaleWindow[Offers.TYPES.PROMOTION_SALE], {
        title: {
            y: { align: "center", dy: 424 },
            width: 390
        },

        description: {
            y: { align: "bottom", dy: 35 }
        },

        header: {
            y: { align: "center", dy: -15 }
        },

        lots: {
            y: { align: "center", dy: -102 },

            marginX: 0
        }
    });
}

if (cleverapps.styles.PromotionSaleLot) {
    cleverapps.overrideStyles(cleverapps.styles.PromotionSaleLot[Offers.TYPES.PROMOTION_SALE], {
        height: 640,

        reward: {
            width: 380,
            height: 443,

            y: { align: "center", dy: 60 },

            margin: {
                x: 5,
                y: 5
            },

            icons: {
                y: { align: "center", dy: 10 },
                wrap: {
                    width: 150,
                    height: 150
                }
            }
        },

        badge: {
            x: { align: "right", dx: 70 },
            y: { align: "top", dy: 10 },
            text: {
                x: { align: "center", dx: 3 },
                y: { align: "center", dy: 3 },
                width: 100,
                height: 80
            }
        },

        button: {
            y: { align: "bottom", dy: 45 }
        }
    });
}

if (cleverapps.styles.TextWithIcon) {
    cleverapps.overrideStyles(cleverapps.styles.TextWithIcon, {
        margin: 4
    });
}

if (cleverapps.styles.ChestPrizeProbWindow) {
    cleverapps.overrideStyles(cleverapps.styles.ChestPrizeProbWindow, {
        prize: {
            probText: {
                y: { align: "bottom", dy: 4 }
            }
        },
        padding: {
            left: -32,
            right: -32
        }
    });
}

if (cleverapps.styles.OpenChestWindow) {
    cleverapps.overrideStyles(cleverapps.styles.OpenChestWindow, {
        showAd: {
            buttons: {
                padding: {
                    top: -10,
                    bottom: 20
                },
                margin: 40
            }
        },

        chest: {
            scale: 1.4,
            margin: 10,
            extra: {
                scale: 1.2
            }
        }
    });
}

if (cleverapps.styles.SellUnitWindow) {
    cleverapps.overrideStyles(cleverapps.styles.SellUnitWindow, {
        icon: {
            scale: 1.3
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.LoadingAnimation, {
    text: {
        x: { align: "center" },
        y: { align: "center", dy: -125 },

        width: 240
    }
});

cleverapps.overrideStyles(cleverapps.styles.GameMessageView, {
    showAnimation: "fromCenter"
});

(function () {
    [
        cleverapps.styles.UI.Button.Images.button_green,
        cleverapps.styles.UI.Button.Images.button_blue,
        cleverapps.styles.UI.Button.Images.button_red,
        cleverapps.styles.UI.Button.Images.button_purple
    ].forEach((obj) => {
        cleverapps.overrideStyles(obj, {
            SKIP_RESOLUTION: {
                padding: {
                    left: 0.3,
                    right: 0.3,
                    top: 0.1,
                    bottom: 0.2
                }
            }
        });
    });

    [
        cleverapps.styles.UI.Button.Images.small_button_blue,
        cleverapps.styles.UI.Button.Images.small_button_green,
        cleverapps.styles.UI.Button.Images.field_button_green,
        cleverapps.styles.UI.Button.Images.field_button_blue
    ].forEach((obj) => {
        cleverapps.overrideStyles(obj, {
            SKIP_RESOLUTION: {
                padding: {
                    left: 0.3,
                    right: 0.3,
                    top: 0.02,
                    bottom: 0.15
                }
            }
        });
    });
}());

if (cleverapps.styles.PrizeCalendarWindow) {
    cleverapps.overrideStyles(cleverapps.styles.PrizeCalendarWindow, {
        bg: {
            outerBg: {
                width: 764,
                height: 900,
                x: { align: "center" },
                y: { align: "center", dy: 8 }
            },
            decorPositions: [
                {
                    x: { align: "left", dx: 35 },
                    y: { align: "top", dy: -35 }
                },
                {
                    x: { align: "right", dx: -35 },
                    y: { align: "top", dy: -35 }
                },
                {
                    x: { align: "left", dx: 35 },
                    y: { align: "bottom", dy: 40 }
                },
                {
                    x: { align: "right", dx: -35 },
                    y: { align: "bottom", dy: 40 }
                }
            ],
            pattern: {
                x: { align: "center" },
                y: { align: "center", dy: 4 }
            }
        },
        margin: 0,
        windowPadding: { x: -18, y: -2, bottom: undefined },
        tiles: {
            margin: {
                x: 70, y: 60
            },
            padding: {
                x: 25,
                top: 0,
                bottom: 60
            }
        },
        ticketAnimation: {
            x: { align: "center", dx: 120 },
            y: { align: "center" },

            delay: {
                reward: 1,
                animation: 0.4
            },
            rewardNode: {
                x: { align: "center", dx: 130 },
                y: { align: "center" }
            }
        }
    });

    cleverapps.overrideStyles(cleverapps.styles.ActiveCalendarTileComponent, {
        titleBg: {
            width: 170,
            height: 50,
            x: { align: "center" },
            y: { align: "bottom", dy: -57 }
        },

        title: {
            x: { align: "center" },
            y: { align: "center", dy: -1 },
            width: 160,
            height: 50
        },

        adIcon: {
            x: { align: "right", dx: 20 },
            y: { align: "center" }
        }
    });
    cleverapps.overrideStyles(cleverapps.styles.PrizeCalendarTileView, {
        mark: {
            x: { align: "center" },
            y: { align: "center", dy: -3 }
        },
        rewards: {
            x: { align: "center" },
            y: { align: "center" },

            fitToBox: {
                width: 120,
                height: 120,

                maxScale: 1
            }
        }
    });

    cleverapps.overrideFonts(cleverapps.styles.FONTS, {
        PRIZE_CALENDAR_TITLE: {
            name: "default",
            size: 40
        }
    });
}

if (cleverapps.styles.BarrelAdsWindow) {
    cleverapps.overrideStyles(cleverapps.styles.BarrelAdsWindow, {
        contentMargin: 35,

        item: {
            height: 555,
            buttonMargin: 25,

            strip: {
                x: { align: "center", dx: 7 },
                y: { align: "bottom", dy: 104 }
            },

            title: {
                x: { align: "center" },
                y: { align: "bottom", dy: 42 }
            },

            button: {
                height: 103
            }
        },

        window: {
            padding: {
                top: 34,
                bottom: 60
            }
        }
    });
}

if (cleverapps.styles.ExpeditionPageView) {
    cleverapps.overrideStyles(cleverapps.styles.ExpeditionPageView, {
        height: 620,

        message: {
            height: 82,
            width: 220,

            x: { align: "center", dx: 46 },
            y: { align: "top", dy: -96 },

            text: {
                x: { align: "center", dx: -6 },
                width: 220,
                height: 70
            },

            icon: {
                width: 70,
                height: 70
            },

            iconBg: {
                x: { align: "left", dx: -47, anchor: 1 }
            }
        },

        button: {
            y: { align: "bottom", dy: 27 }
        }
    });
}

if (cleverapps.styles.BoostersBeforeComponent) {
    cleverapps.overrideStyles(cleverapps.styles.BoostersBeforeComponent, {
        lantern: {
            boostersMargin: 35,
            contentMargin: 15
        }
    });
}

if (cleverapps.styles.PackOfferComponent && cleverapps.styles.PackOfferComponent[Offers.TYPES.STICKERS_PACK]) {
    cleverapps.overrideStyles(cleverapps.styles.PackOfferComponent[Offers.TYPES.STICKERS_PACK], {
        pack: {
            offsetY: 420,
            badge: {
                x: { align: "right", dx: 40 },
                y: { align: "top", dy: 45 },
                rotation: 30
            }
        },
        tap: {
            x: { align: "center", dx: 10 },
            y: { align: "center", dy: -80 },
            rotation: 0,
            scaleX: 1
        }
    });
}

if (cleverapps.styles.OpenLetterButtonBooster) {
    cleverapps.overrideStyles(cleverapps.styles.OpenLetterButtonBooster, {
        height: 110,
        content: {
            margin: 5,
            layout: {
                y: { align: "center", dy: 30 }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.RestoreProgressButton, {
    height: 100
});

if (cleverapps.styles.HintButtonBooster) {
    cleverapps.overrideStyles(cleverapps.styles.HintButtonBooster, {
        width: 150,
        height: 110,

        content: {
            margin: -9,
            direction: cleverapps.UI.VERTICAL,
            layout: {
                y: { align: "center", dy: 28 }
            }
        }
    });
}

if (cleverapps.styles.BonusLevelChest) {
    cleverapps.overrideStyles(cleverapps.styles.BonusLevelChest, {
        chest: {
            y: { align: "top", dy: 230 },

            vertical: {
                x: { align: "center", dx: 0 },
                y: { align: "top", dy: 170 }
            }
        },

        timer: {
            height: 50,
            y: { align: "top", dy: 20 },
            countdown: {
                x: { align: "center", dx: 10 },
                y: { align: "center", dy: 0 }
            },
            vertical: {
                y: { align: "top", dy: 10 }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.RowView, {
    width: 1060,
    height: 137,

    paddingX: 36,

    content: {
        height: 96,
        y: { align: "center", dy: 3 }
    },

    place: {
        withBadge: {
            width: 60
        },
        width: 50
    },

    name: {
        x: { align: "left" }
    },

    prize: {
        width: 110,
        verticalWidth: 110
    },

    score: {
        width: 160,
        verticalWidth: 130,
        height: 64
    }
});

cleverapps.overrideStyles(cleverapps.styles.DefaultTableStyles, {
    margin: -6
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ROW_PLAYER_TEXT: {
        name: "nostroke",
        size: 45,
        color: new cc.Color(70, 113, 0, 255)
    },

    ROW_TEXT: {
        name: "nostroke",
        size: 45,
        color: new cc.Color(142, 77, 60, 255)
    },

    ROW_SCORE_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

if (cleverapps.styles.ScoreBarRewardWindow) {
    cleverapps.overrideStyles(cleverapps.styles.ScoreBarRewardWindow, {
        height: 1200,
        bg: {
            x: { align: "center" },
            y: { align: "center" }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.UI.Tooltip, {
    content: {
        offset: {
            y: 2
        }
    }
});

if (cleverapps.styles.ExtraBarIconView) {
    cleverapps.overrideStyles(cleverapps.styles.ExtraBarIconView, {
        title: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 0 },

            width: 130,
            height: 26,
            offsetY: 0
        },

        icon: {
            x: { align: "center" },
            y: { align: "center", dy: 8 }
        },

        background: {
            x: { align: "center" },
            y: { align: "center", dy: -20 }
        }
    });
}

if (cleverapps.styles.ProfileWindow) {
    cleverapps.overrideStyles(cleverapps.styles.ProfileWindow, {
        nameGenerator: {
            button: {
                type: cleverapps.styles.UI.Button.Images.small_button_green
            },

            bg: {
                x: { align: "right", dx: -10 },
                y: { align: "center" },

                padding: {
                    y: 5
                }
            },

            nickname: {
                offsetY: 3,
                line: undefined
            }
        },

        avatarPicker: {
            avatarsBox: {
                margin: { x: 30, y: 30 },
                padding: { y: 30 },

                avatar: {
                    mark: {
                        x: { align: "right", dx: 5 },
                        y: { align: "bottom", dy: -5 }
                    }
                }
            },

            scroll: {
                width: 1000,
                height: 560
            }
        },

        buttonsBox: {
            margin: 140
        },

        button: {
            width: 320
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.Timer, {
    timer: {
        x: { align: "center", dx: 16 },
        y: { align: "center", dy: 5 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.UI.ImageFont, {
    SKIP_RESOLUTION: {
        DESCENTS: {
            "fonts/shantellsans-extrabold": 0,
            "fonts/shantellsans-nostroke": 0
        }
    }
});